(function () {
    // Accordions - open/close
    const allAccordions = document.querySelectorAll('.accordion');
    if (allAccordions) {
        allAccordions.forEach((oneAccordion) => {
            const theAccordionHeader = oneAccordion.querySelector('button.accordion-header');
            theAccordionHeader.addEventListener('click', function () {
                const isExpanded = this.getAttribute('aria-expanded');
                const accordionBody = oneAccordion.querySelector('.accordion-body');

                if (isExpanded === 'true') {
                    accordionBody.style.display = 'none';
                    this.setAttribute('aria-expanded', false);
                } else {
                    accordionBody.style.display = 'block';
                    this.setAttribute('aria-expanded', true);
                }
            });
        });
    }
})();
